"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkMetaData = checkMetaData;
const protocol_1 = require("../protocol");
function checkMetaData(dappMetaData) {
    if (!dappMetaData) {
        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.BAD_REQUEST_ERROR, "You have to specify a `dappMetaData`in the options.");
    }
    if (!dappMetaData.name) {
        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.BAD_REQUEST_ERROR, "dappName is required");
    }
    if (!dappMetaData.icon) {
        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.BAD_REQUEST_ERROR, "icon is required");
    }
    return true;
}
